import { render, staticRenderFns } from "./modifyPage.vue?vue&type=template&id=df05b49e&scoped=true"
import script from "./modifyPage.vue?vue&type=script&lang=js"
export * from "./modifyPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df05b49e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-producerPlatform-fe/treasurenet-tnservices-producerPlatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df05b49e')) {
      api.createRecord('df05b49e', component.options)
    } else {
      api.reload('df05b49e', component.options)
    }
    module.hot.accept("./modifyPage.vue?vue&type=template&id=df05b49e&scoped=true", function () {
      api.rerender('df05b49e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wellManage/myWells/modifyPage.vue"
export default component.exports